import React from 'react';
import PropTypes from 'prop-types';

function R2Button({ activeColor, color, value }) {
  return (
    <>
      <path
        d="M636.678 97.3108C636.678 97.3108 610.316 94.812 595.885 94.812C581.453 94.812 556.863 96.6861 556.863 96.6861C556.863 96.6861 559.363 61.7837 560.734 56.0838C562.104 50.3839 566.939 39.4525 574.358 34.2991C581.776 29.1458 584.032 26.413 592.738 26.413C601.449 26.413 613.218 31.4101 620.637 43.1223C628.051 54.8345 636.678 97.3108 636.678 97.3108Z"
        fill={color}
      />
      <path
        d="M636.678 97.3108C636.678 97.3108 610.316 94.812 595.885 94.812C581.453 94.812 556.863 96.6861 556.863 96.6861C556.863 96.6861 559.363 61.7837 560.734 56.0838C562.104 50.3839 566.939 39.4525 574.358 34.2991C581.776 29.1458 584.032 26.413 592.738 26.413C601.449 26.413 613.218 31.4101 620.637 43.1223C628.051 54.8345 636.678 97.3108 636.678 97.3108Z"
        fill={activeColor}
        stroke={activeColor}
        strokeWidth="3px"
        style={{ opacity: value }}
      />
    </>
  );
}

R2Button.propTypes = {
  activeColor: PropTypes.string,
  color: PropTypes.string,
  value: PropTypes.number,
};

R2Button.defaultProps = {
  activeColor: '#FFFFFF',
  color: '#000201',
  value: 0,
};

export default R2Button;
